export const resolveLinkMarketingCopy = (linkMarketingCopy, url) => {
    if (!linkMarketingCopy) {
        return url;
    }
    if (linkMarketingCopy.includes('$url')) {
        return linkMarketingCopy.replace(/\$url/g, url);
    }
    return `${linkMarketingCopy} ${url}`;
};
